import { observer } from 'mobx-react';
import * as React from 'react';

import TransComp from 'shared/components/TransComp';
import { usePageTemplateMenuStore } from 'stores/PageTemplateMenuStore';

import ProjectItem from './ProjectItem';
import CabinetItem from './CabinetItem';
import HomeItem from './HomeItem';
import Arrow from './Arrow';
import BreadcrumbItem from './BreadcrumbItem';

import './Breadcrumbs.modules.scss';

const Breadcrumbs: React.FC = () => {
  const menuStore = usePageTemplateMenuStore();

  return (
    <div styleName="breadcrumbs">
      <div styleName="breadcrumbs__part">
        <div styleName="breadcrumbs__part">
          <HomeItem styleName="breadcrumbs__home" />
          <div styleName="breadcrumbs__item">
            <CabinetItem />
          </div>
        </div>
        <ProjectItem withArrow={!!menuStore.activeSection} />
      </div>
      {menuStore.activeSection && (
        <>
          <div styleName="breadcrumbs__part">
            <BreadcrumbItem
              action={menuStore.activeSection.action}
              isActive={!menuStore.activeSectionChild.value}
              styleName="breadcrumbs__item breadcrumbs__active-child"
            >
              <TransComp>{menuStore.activeSection.title}</TransComp>
            </BreadcrumbItem>
            {menuStore.activeSectionChild.value && (
              <Arrow styleName="breadcrumbs__item" />
            )}
          </div>
          {menuStore.activeSectionChild.value && (
            <BreadcrumbItem
              action={menuStore.activeSectionChild.value.action}
              isActive
              styleName="breadcrumbs__active-child"
            >
              {menuStore.activeSectionChild.value.title}
            </BreadcrumbItem>
          )}
        </>
      )}
    </div>
  );
};

export default observer(Breadcrumbs);
